import { Dialog } from "@/components/Modal/Dialog";
import { IconActionCheckAlt } from "@/components/Icons";
import React from "react";
import { AdmissionResponseType } from "@/hooks/useAdmissionResponseSuccess";
import { Assert } from "@/utils/assert";

function getText(admissionResponseType: AdmissionResponseType): string {
  switch (admissionResponseType) {
    case AdmissionResponseType.OfferAccepted:
      return "Admission offer accepted";
    case AdmissionResponseType.OfferRejected:
      return "Admission offer declined";
    case AdmissionResponseType.SimplifiedProcessJoin:
      return "Successfully joined";
  }
  Assert.notImplemented(`Unknown response type ${admissionResponseType}`);
}

export function AdmissionResponseSuccessDialog(props: {
  open: boolean;
  admissionResponseType: AdmissionResponseType;
}) {
  const text = getText(props.admissionResponseType);
  return (
    <Dialog open={props.open} onClose={() => {}} disableClose>
      <div className="mt-xl">
        <div className="flex justify-center mb-lg">
          <span className="w-2xl h-2xl">
            <IconActionCheckAlt className="w-2xl h-2xl text-green-120" />
          </span>
        </div>
        <div className="flex justify-center">
          <span className="text-style-headline4">{text}</span>
        </div>
      </div>
    </Dialog>
  );
}
